<div class="w-full pb-xl">
    <iframe class="w-full h-[14rem]" [src]="url | safeResourceUrl" title="Login Form"></iframe>
    <div class="mb-lg">
        <span class="text-sm font-semibold pr-lg">Forgot password?</span
        ><a class="text-primary-dark underline cursor-pointer" (click)="forgetPassword()">Reset Password</a>
    </div>
    <div>
        <span class="text-sm font-semibold pr-lg">Not a member yet?</span
        ><a class="text-primary-dark underline cursor-pointer" (click)="createAccount()">Create an Account</a>
    </div>
</div>
<hlm-sheet #sheet side="bottom" class="create-account-sheet" data-testid="create-account-sheet" (closed)="onNestedSheetClosed()">
    <hlm-sheet-content *brnSheetContent="let ctx" class="[&>button]:hidden">
        <hlm-sheet-header class="pl-0 flex-shrink-0 pt-[50px]">
            <div class="flex items-center justify-between mt-2 pr-2">
                <h1 hlmSheetTitle class="text-lg">Create Account</h1>

                <ng-icon
                    hlm
                    name="lucideX"
                    size="base"
                    (click)="sheetRef()?.close()"
                    class="cursor-pointer text-gray-500 hover:text-gray-700 flex-shrink-0"
                ></ng-icon>
            </div>
        </hlm-sheet-header>
        <div class="overflow-y-auto">
            <app-create-account-form (accountCreated)="onCloseContainer()"></app-create-account-form>
        </div>
    </hlm-sheet-content>
</hlm-sheet>
